import { speed } from 'Lib/speed/speed';
import { isTouch } from 'Lib/istouch/istouch';
import { isNoEmptyString } from 'Lib/is-no-empty-string/is-no-empty-string';
import { CheckboxAccept } from 'Lib/checkbox-accept/checkbox-accept';

const $manuscriptSelectbox = $('.services-author__choice-manuscript-selectbox');
const isPackage = !!$('.services-author__package-total-price').hasClass('services-author__package-total-price_package');
let isSelectedManuscript = !$manuscriptSelectbox.length || !!$manuscriptSelectbox.find('.selectbox__option_active').length;
const cPackageOrItem = isPackage ? '.services-author__choice-list_package' : '.services-author__choice-item_selected';
const $choiceItemTabLink = $('.services-author__choice-item-tab-link');
const checkboxes = new CheckboxAccept(
    'services_lk',
    '.services-author__form-block',
    '.checkbox input',
    '.checkbox__content-offset',
    null,
    document.querySelector('.services-author__form-block'),
);

checkboxes.setEventCheckboxAccept();

// Нажатие на кнопку "Заказать/Скрыть"
$(document).on('click', '.services-author__btn:not(.btn_disabled)', function () {
    const $this = $(this);
    const $item = $this.closest('.services-author__item');
    const $choice = $item.find('.services-author__choice');
    const $btnMore = $item.find('.services-author__btn_more');
    const $btnHide = $item.find('.services-author__btn_hide');

    if ($this.hasClass('services-author__btn_more')) {
        $choice.slideDown(speed);
        $btnMore.hide();
        $btnHide.show();
    } else if ($this.hasClass('services-author__btn_hide')) {
        $choice.slideUp(speed);
        $btnHide.hide();
        $btnMore.show();
    }
});

// Нажатие на кнопку "Выбрать/Отменить выбор" в выборе варианта услуги
$(document).on('click', '.services-author__choice-btn:not(.btn_disabled)', function () {
    const $this = $(this);
    const $item = $this.closest('.services-author__item');
    const $choice = $this.closest('.services-author__choice');
    const $choiceItem = isPackage ? $this.closest('.services-author__choice-list') : $this.closest('.services-author__choice-item');
    const $formBlock = $choice.find('.services-author__form-block');
    const cBtnDisabled = 'btn_disabled';
    const cItemDisabled = 'services-author__item_disabled';
    const $calculatorInput = $choiceItem.find('.services-author__calculator-input');

    if ($this.hasClass('services-author__choice-btn_selection')) { // Нажатие на выбрать
        if ($calculatorInput.length > 0 && $calculatorInput.val() <= 0) { // Если есть калькулятор и результат нулевой
            $.fancybox.open('<div><p class="text text_c-gray">Пожалуйста введите кол-во АЛ</p></div>');
        } else {
            $calculatorInput.prop('readonly', true);
            $choiceItem.find('.services-author__choice-btn_selection').hide();
            $choiceItem.addClass('services-author__choice-item_selected');
            $choiceItem.find('.services-author__choice-btn_deselection').css('display', 'table');
            $('.services-author__btn_more, .services-author__choice-btn_selection').addClass(cBtnDisabled);
            $item.find('.services-author__btn_hide').hide();
            $item.siblings('.services-author__item').addClass(cItemDisabled);
            $formBlock.addClass(`services-author__form-block_order-${$choiceItem.attr('data-num')}`);
            $formBlock.slideDown(speed);
        }
    } else if ($this.hasClass('services-author__choice-btn_deselection')) { // Нажатие на отменить
        $calculatorInput.prop('readonly', false);
        $choiceItem.find('.services-author__choice-btn_deselection').hide();
        $choiceItem.removeClass('services-author__choice-item_selected');
        $choiceItem.find('.services-author__choice-btn_selection').show();
        $('.services-author__btn_more, .services-author__choice-btn_selection').removeClass(cBtnDisabled);
        $item.find('.services-author__btn_hide').show();
        $item.siblings('.services-author__item').removeClass(cItemDisabled);
        $formBlock.slideUp(speed);
        $formBlock.removeClass(`services-author__form-block_order-${$choiceItem.attr('data-num')}`);
    }
});

// Изменение чекбокса соглашения
$('.services-author__checkbox').on('eksmoChangeCheckbox', function (e, checked) {
    const $submit = $(this).closest('.services-author__choice').find('.services-author__submit');
    const cBtnDisabled = 'btn_disabled';

    if (isSelectedManuscript) {
        $submit.toggleClass(cBtnDisabled, !checked).prop('disabled', !checked);
    }
});

// Клик на "подробнее" в тексте согласия
$('.services-author__guarantees-btn').on('click', () => {
    $.fancybox.close();

    $.fancybox.open({
        type: 'html',
        src: $('.services-author__guarantees-modal').html(),
        baseClass: 'services-author__fancybox-guarantees',
        touch: false,
    });
});

// Изменение выбора рукописи на странице услуги
$manuscriptSelectbox.on('changed.selectbox.eksmo', function (e, value) {
    const $this = $(this);
    const $btnSubmit = $('.services-author__submit');
    const $selectedOption = $this.find(`option[value='${value}']`);
    const price1 = $selectedOption.attr('data-price1');
    const price2 = $selectedOption.attr('data-price2');
    const price3 = $selectedOption.attr('data-price3');
    const $price = $this.closest('.services-author__choice').find('.services-author__choice-price');
    const $choice = $this.closest('.services-author__choice');
    // Корректура (proofreading) - используется индивидуальная цена для каждой рукописи из атрибута в option
    const priceProofreading = $selectedOption.attr('data-price-proofreading');
    const $priceProofreading = $choice.find('.services-author__choice-item-wrap_price-proofreading .services-author__choice-price');

    if (isNoEmptyString(priceProofreading) && $priceProofreading.length) {
        const priceProofreadingOld = $selectedOption.attr('data-price-proofreading-old');
        const $priceProofreadingOld = $choice.find('.services-author__choice-item-wrap_price-proofreading .services-author__choice-price-old');

        $priceProofreading.attr('data-price', `${priceProofreading}.00`);
        $priceProofreading.html(`${numberWithSpaces(priceProofreading)} ₽`);

        if ($priceProofreadingOld.length && isNoEmptyString(priceProofreadingOld) && $priceProofreadingOld.length) {
            $priceProofreadingOld.attr('data-price-old', `${priceProofreadingOld}.00`);
            $priceProofreadingOld.html(`${numberWithSpaces(priceProofreadingOld)} ₽`);
        } else {
            $priceProofreadingOld.remove();
        }

        setPricesPackageServices();
    }

    // Редактура (editing) - используется индивидуальная цена для каждой рукописи из атрибутов в option
    // (data-price-editing-standard, data-price-editing-advanced)
    const priceEditingStandard = $selectedOption.attr('data-price-editing-standard');
    const priceEditingAdvanced = $selectedOption.attr('data-price-editing-advanced');
    const $priceEditing = $choice.find('.services-author__choice-item-wrap_price-editing');

    if (isNoEmptyString(priceEditingStandard) && isNoEmptyString(priceEditingAdvanced) && $priceEditing.length) {
        const $standardTab = $priceEditing.find('.services-author__choice-item-tabs').eq(0);
        const $advancedTab = $priceEditing.find('.services-author__choice-item-tabs').eq(1);
        const $editingStandard = $standardTab.find('.services-author__choice-price');
        const $editingAdvanced = $advancedTab.find('.services-author__choice-price');
        const priceEditingOldStandard = $selectedOption.attr('data-price-editing-old-standard');
        const priceEditingOldAdvanced = $selectedOption.attr('data-price-editing-old-advanced');
        const $editingStandardOld = $standardTab.find('.services-author__choice-price-old');
        const $editingAdvancedOld = $advancedTab.find('.services-author__choice-price-old');
        const $choiceStandardTabLink = $choiceItemTabLink.eq(0);
        const $choiceAdvancedTabLink = $choiceItemTabLink.eq(1);
        const $standardPriceOld = $choiceStandardTabLink.find('.services-author__choice-item-tab-link-old-price');
        const $advancedPriceOld = $choiceAdvancedTabLink.find('.services-author__choice-item-tab-link-old-price');

        // Замена цены в табе на цену указанную в атрибуте option рукописи
        $editingStandard.attr('data-price', `${priceEditingStandard}.00`);
        $editingStandard.html(`${numberWithSpaces(priceEditingStandard)} ₽`);
        $editingAdvanced.attr('data-price', `${priceEditingAdvanced}.00`);
        $editingAdvanced.html(`${numberWithSpaces(priceEditingAdvanced)} ₽`);
        // Замена цены в всплывающем меню с выбором тарифа на цену указанную в атрибуте option рукописи
        $choiceStandardTabLink.find('.services-author__choice-item-tab-link-price').html(`${numberWithSpaces(priceEditingStandard)} ₽`);
        $choiceAdvancedTabLink.find('.services-author__choice-item-tab-link-price').html(`${numberWithSpaces(priceEditingAdvanced)} ₽`);

        if (isNoEmptyString(priceEditingOldStandard) && isNoEmptyString(priceEditingOldAdvanced)
            && $editingStandardOld.length && $editingAdvancedOld.length) {
            $editingStandardOld.attr('data-price-old', `${priceEditingOldStandard}.00`);
            $editingStandardOld.html(`${numberWithSpaces(priceEditingOldStandard)} ₽`);
            $editingAdvancedOld.attr('data-price-old', `${priceEditingOldAdvanced}.00`);
            $editingAdvancedOld.html(`${numberWithSpaces(priceEditingOldAdvanced)} ₽`);
            $standardPriceOld.html(`${numberWithSpaces(priceEditingOldStandard)} ₽`);
            $advancedPriceOld.html(`${numberWithSpaces(priceEditingOldAdvanced)} ₽`);
        } else {
            $editingStandardOld.remove();
            $editingAdvancedOld.remove();
            $standardPriceOld.remove();
            $advancedPriceOld.remove();
        }

        setPricesPackageServices();
    }

    if (isNoEmptyString(price1)) {
        $price.eq(0).attr('data-price', `${price1}.00`);
        $price.eq(0).html(`${numberWithSpaces(price1)} ₽`);
    }

    if (isNoEmptyString(price2)) {
        $price.eq(1).attr('data-price', `${price2}.00`);
        $price.eq(1).html(`${numberWithSpaces(price2)} ₽`);
    }

    if (isNoEmptyString(price3)) {
        $price.eq(2).attr('data-price', `${price3}.00`);
        $price.eq(2).html(`${numberWithSpaces(price3)} ₽`);
    }

    manuscriptSelection($this, value);
    isSelectedManuscript = true;

    if ($('.services-author__checkbox input').prop('checked')) {
        $btnSubmit.removeAttr('disabled');
        $btnSubmit.removeClass('btn_disabled');
    }
});

// Если на странице услуги рукопись изначально уже выбрана
if ($('.services-author__choice-manuscript-selectbox select option').filter('[selected]').length !== 0) {
    manuscriptSelection($manuscriptSelectbox);
}

// Заполнение/Очистка файлового поля
$('.services-author__fileinput').on('filled.fileinput.eksmo', function () {
    const $form = $(this);
    const $choice = $form.closest('.services-author__choice');
    const formdata = new FormData($form[0]);

    $.ajax({
        type: 'POST',
        url: $form.attr('data-url'),
        data: formdata,
        dataType: 'json',
        processData: false,
        contentType: false,
        success(data) {
            if (typeof data.error === 'string') {
                $.fancybox.open(`<div class="manuscript-form__message"><p class="text text_c-gray">Ошибка</p><p>"${data.error}"</p></div>`);
                cancelFile($form);
            } else if (data.id !== undefined) {
                if ($choice.find('.services-author__choice-item_selected').length === 0) {
                    $choice.find('.services-author__choice-btn').removeClass('btn_disabled');
                }

                $choice.find('.services-author__submit').attr('data-manuscript-id', data.id);
            } else {
                $.fancybox.open('<div class="manuscript-form__message"><p class="text text_c-gray">Ошибка</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
                cancelFile($form);
            }
        },
        error() {
            $.fancybox.open('<div class="manuscript-form__message"><p class="text text_c-gray">Ошибка</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
            cancelFile($form);
        },
    });
})
    .on('cleared.fileinput.eksmo', function () {
        cancelFile($(this));
    });

function cancelFile(fileinput) {
    const $choice = fileinput.closest('.services-author__choice');
    const cChoiceSelected = 'services-author__choice-item_selected';
    const $choiceSelected = $choice.find(`.${cChoiceSelected}`);

    $choice.find('.services-author__choice-btn').addClass('btn_disabled');
    $choice.find('.services-author__submit').attr('data-manuscript-id', '');

    if ($choiceSelected.length > 0) {
        const $formBlock = $choiceSelected.closest('.services-author__choice').find('.services-author__form-block');

        $choiceSelected.find('.services-author__choice-btn_deselection').hide();
        $choiceSelected.removeClass(cChoiceSelected);
        $choiceSelected.find('.services-author__choice-btn_selection').show();
        $formBlock.slideUp(speed);
        $formBlock.removeClass(`services-author__form-block_order-${$choiceSelected.attr('data-num')}`);
    }
}

function manuscriptSelection(element, value) {
    const sServicesAuthor = '.services-author';

    if (element.closest(sServicesAuthor).find('.services-author__form-block:visible').length === 0) { // Если вариант услуги не выбран
        element.closest(sServicesAuthor).find('.services-author__choice-btn').removeClass('btn_disabled');
    }

    if (typeof value !== 'undefined') {
        element.closest('.services-author__choice').find('.services-author__submit').attr('data-manuscript-id', value);
    }
}

// Нажатие на ссылку "Подробнее" в описании услуги
$('.services-author__link-detailed').on('click', function () {
    $.fancybox.close();

    $.fancybox.open({
        type: 'html',
        src: $(this).closest('.services-author__item').find('.services-author__detailed-modal').html(),
        baseClass: 'services-author__fancybox-detailed-modal',
        touch: false,
    });
});

// Нажатие на ссылку "Смотреть примеры" в вариенте услуги
$(document).on('click', '.services-author__choice-link', function () {
    const $this = $(this);

    $.fancybox.close();

    $.fancybox.open({
        type: 'html',
        src: $(`.services-author__examples-covers-modal[data-cover=${$this.attr('data-cover')}]`).html(),
        touch: false,
    });
});

// калькулятор АЛ(Авторских листов)
$('.services-author__calculator-input').on('change keyup paste', function () {
    const $this = $(this);
    const multiplier = $this.attr('data-price-multiplier');

    if (typeof multiplier !== 'undefined' && multiplier > 0) {
        const result = $this.val() * multiplier;

        $this.closest('.services-author__choice-item').find('.services-author__calculator-result').text((result).toLocaleString());
        $this.closest('.services-author__choice-item').find('.services-author__choice-price').attr('data-price', `${result}.00`);
    } else {
        $this.val('');
        $.fancybox.open(`<div><p class="text text_c-gray">Ошибка</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>`);
    }
});

// Нажатие на заблокированной услуге на touch устройствах
if (isTouch()) {
    $('.services-author__item_disabled').on('click', function () {
        $.fancybox.close();
        $.fancybox.open(`<div><p class="text text_c-gray">${$(this).find('.services-author__item-tip .tip__style').text()}</p></div>`);
    });
}

// Оплата
function pay(btn) {
    const $this = btn;
    const $choiceBlock = $this.closest('.services-author__choice');
    const price = isPackage ? +$choiceBlock.find('.services-author__package-total-price .services-author__choice-price_total').attr('data-price') : +$choiceBlock.find('.services-author__choice-item_selected .services-author__choice-price').attr('data-price');
    const serviceTypeName = $choiceBlock.find(cPackageOrItem).attr('data-element-name');
    const redirectSuccessUrl = `${$this.attr('data-success-redirect') + $this.attr('data-manuscript-id')}/`;
    const receipt = {
        'Items': [
            // товарные позиции
        ],
        'TaxationSystem': 0,
        'amounts': {
            electronic: price,
        },
    };
    const widget = new window.cp.CloudPayments();

    if (isPackage) {
        $('.services-author__choice-item-wrap').each(function () {
            const $th = $(this);
            const priceService = $th.find('.services-author__choice-item-tabs_active').length ? $th.find('.services-author__choice-item-tabs_active .services-author__choice-price').first().attr('data-price') : $th.find('.services-author__choice-price').first().attr('data-price');

            receipt.Items.push({
                'label': $th.find('.services-author__choice-item-title-span').first().text(), // наименование товара
                'price': priceService, // цена
                'quantity': '1.00', // количество
                'amount': priceService, // сумма
                'vat': +$this.attr('data-vat'), // ставка НДС
                'method': 1,
                'object': 4, // тег-1212 признак предмета расчета - признак предмета товара, работы, услуги, платежа, выплаты, иного предмета расчета
                'measurementUnit': $this.attr('data-measure'), // единица измерения
            });
        });
    } else {
        receipt.Items.push({
            'label': serviceTypeName, // наименование товара
            'price': price, // цена
            'quantity': '1.00', // количество
            'amount': price, // сумма
            'vat': +$this.attr('data-vat'), // ставка НДС
            'method': 1,
            'object': 4, // тег-1212 признак предмета расчета - признак предмета товара, работы, услуги, платежа, выплаты, иного предмета расчета
            'measurementUnit': $this.attr('data-measure'), // единица измерения
        });
    }

    // Когда будет задача связанная с услугами, перенести оплату на либу cloudpayments.js
    widget.charge({ // (для одностадийного платежа)
        //      widget.auth({ // (для двухстадийного)
        publicId: $this.attr('data-cloud-payments-id'), // id из личного кабинета
        description: `${$this.attr('data-description')}: ${serviceTypeName}`, // назначение
        amount: price, // сумма
        email: $this.attr('data-user-email'),
        currency: 'RUB', // валюта
        invoiceId: $this.attr('data-invoice-id'), // номер заказа  (необязательно)
        //      accountId: '321', //идентификатор плательщика (необязательно)
        requireEmail: true,
        skin: 'classic', // дизайн виджета
        data: {
            'guid': $choiceBlock.find(cPackageOrItem).attr('data-element-guid'),
            'uid': $choiceBlock.find(cPackageOrItem).attr('data-element-uid'),
            'elementid': $this.attr('data-manuscript-id'),
            'serviceid': $this.attr('data-service-id'),
            'comment': $choiceBlock.find('.services-author__textarea').val(),
            'service': 'crm_authors',
            'cloudPayments': {
                'CustomerReceipt': receipt, // онлайн-чек
            },
            'email': $this.attr('data-user-email'),
        },
    },
    (/* options */) => { // success
        // действие при успешной оплате
        if (typeof redirectSuccessUrl !== 'undefined' && redirectSuccessUrl.length) {
            setTimeout(() => {
                window.location.href = redirectSuccessUrl;
            }, 1500);
        } else {
            setTimeout(() => {
                window.location.reload();
            }, 1500);
        }
    },
    (/* reason, options */) => { // fail
        // действие при неуспешной оплате
    });
}

// Нажатие кнопки "Оплатить"
$(document).on('click', '.services-author__submit:not(.btn_disabled)', function () {
    pay($(this));
});

// Функция добавления пробелов между разрядами в числах
function numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

// Используется для подсчёта суммы пакетной услуги, для переключения услуг в формировании пакета
function setPricesPackageServices($th) {
    let priceTotal = 0;
    let priceTotalOld = 0;
    const sTabLinkActive = 'services-author__choice-item-tab-link_active';
    const sTabActive = 'services-author__choice-item-tabs_active';
    const $choiceItemTabs = $('.services-author__choice-item-tabs');
    const $totalPrice = $('.services-author__package-total-price .services-author__choice-price');
    const $totalPriceOld = $('.services-author__package-total-price .services-author__choice-price-old');
    let guids = '';

    if ($th) {
        guids += $th.attr('data-element-guid');
        $choiceItemTabLink.removeClass(sTabLinkActive);
        $choiceItemTabLink.find('.radio').removeClass('radio_active');
        $th.addClass(sTabLinkActive);
        $('.services-author__menu-personal-service').trigger('eksmoMMenuClose');
        $th.find('.radio').addClass('radio_active');
        $choiceItemTabs.removeClass(sTabActive);
        $choiceItemTabs.eq($th.index()).addClass(sTabActive);
        $('.services-author__choice-item-title-span_list').text($th.find('.services-author__choice-item-tab-title').text());
    }

    $('.services-author__choice-item-wrap').each(function () {
        const $this = $(this);

        if ($th && $this.attr('data-element-guid')) {
            if (guids !== '') {
                guids += `, ${$this.attr('data-element-guid')}`;
            } else {
                guids += `${$this.attr('data-element-guid')}`;
            }
        }

        if ($this.hasClass('services-author__choice-item-wrap_list') && $this.closest(`.${sTabActive}`)) {
            priceTotal += Number($this.find(`.${sTabActive} .services-author__choice-price`).attr('data-price'));
            priceTotalOld += Number($this.find(`.${sTabActive} .services-author__choice-price-old`).attr('data-price-old'));
        } else {
            priceTotal += Number($this.find('.services-author__choice-price').first().attr('data-price'));
            priceTotalOld += Number($this.find(`.services-author__choice-price-old`).attr('data-price-old'));
        }
    });

    if (guids) {
        $(cPackageOrItem).attr('data-element-guid', guids);
    }

    $totalPrice.attr('data-price', priceTotal);
    $totalPrice.text(`${new Intl.NumberFormat('ru-RU').format(priceTotal)} ₽`);

    if (Number(priceTotalOld)) {
        $totalPriceOld.text(`${new Intl.NumberFormat('ru-RU').format(priceTotalOld)} ₽`);
    } else {
        $totalPriceOld.remove();
    }
}

$choiceItemTabLink.on('click', function () {
    setPricesPackageServices($(this));
});